module.exports = __webpack_public_path__ + "static/media/credit1.9fc8c71f.png";